import styles from "./m3.module.css";

/**
 * Large selectable cards for picking a mode, each with a one-line explanation.
 * Use when the choice changes what the rest of a form asks for.
 *
 * @param {Array} options - { value, label, description, icon?, badge? }
 */
const ModeSelector = ({ options = [], value, onChange, ariaLabel }) => (
  <div className={styles.modeGroup} role="radiogroup" aria-label={ariaLabel}>
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={active}
          className={`${styles.modeCard} ${active ? styles.modeCardActive : ""}`}
          onClick={() => onChange(opt.value)}
        >
          <span className={styles.modeCardHead}>
            {opt.icon}
            {opt.label}
            {opt.badge && <span className={styles.modeCardBadge}>{opt.badge}</span>}
          </span>
          {opt.description && <span className={styles.modeCardDesc}>{opt.description}</span>}
        </button>
      );
    })}
  </div>
);

export default ModeSelector;
